import { StatusIcon } from '@strata/react-status-icons';

import { IntakeStatusDetails, StatusDetailsDisplayStrings } from 'services/constants';

export const getIntakeStatusDetails = (
    status?: (typeof IntakeStatusDetails)[keyof typeof IntakeStatusDetails],
) => {
    if (!status) {
        return undefined;
    }

    return (
        <div className="flex__gap--x-small" style={{ alignItems: 'center' }}>
            {status === IntakeStatusDetails.PA_FAILED && (
                <StatusIcon status={StatusIcon.Statuses.CAUTION} />
            )}
            {StatusDetailsDisplayStrings[status]}
        </div>
    );
};
